<template>
  <div class="row">
    <div v-if="title" class="col-sm-12 my-3">
      <h3>
        <span>{{ title }}</span>
        <button v-if="add && !edit" class="btn btn-link btn-sm btn-fill btn-wd float-right" @click="$emit('edit')">
          <i class="fas fa-plus mr-1"></i>Agregar Articulos
        </button>
      </h3>
    </div>

    <!-- SM MD LG XL -->
    <div class="col-sm-12 mb-4 d-none d-sm-block">
      <div class="row">
        <div class="col-sm-2"><h4>Código</h4></div>
        <div :class="{ 'col-sm-2': edit, 'col-sm-4': !edit }"><h4>Artículo</h4></div>
        <div class="col-sm-2 text-center"><h4>Cantidad</h4></div>
        <div class="col-sm-2 text-center"><h4>Precio Unitario</h4></div>
        <div class="col-sm-2 text-center"><h4>Importe (USD)</h4></div>
      </div>
    </div>

    <!-- SM MD LG XL -->
    <div v-for="(item, index) in items" :key="'normal' + index" class="col-sm-12 d-none d-sm-block">
      <div class="row">
        <div class="col-sm-2">
          <small>{{ item.article.code }}</small>
        </div>
        <div :class="{ 'col-sm-2': edit, 'col-sm-4': !edit }">
          <small>{{ item.article.description }}</small>
        </div>
        <div class="col-sm-2 text-center">
          <small>{{ item.quantity }}</small>
        </div>
        <div class="col-sm-2 text-center">
          <small>{{ item.price }}</small>
        </div>
        <div class="col-sm-2 text-center">
          <small>{{ (item.price * item.quantity).toFixed(2) }}</small>
        </div>
        <div v-if="edit" class="col-sm-2">
          <base-button
            class="rounded-pill btn btn-danger"
            title="Eliminar"
            size="sm"
            type="danger"
            @click="deleteItem(item.id, index)"
          >
            <i class="fas fa-trash mr-1"></i>Eliminar
          </base-button>
        </div>
      </div>
      <hr />
    </div>

    <!-- XS -->
    <div v-for="(item, index) in items" :key="'xs' + index" class="col-sm-12 d-block d-sm-none">
      <div class="row">
        <div class="col-12">
          <!--          <h5 class="d-inline-block mr-1">Cod:</h5>-->
          <small>{{ item.article.code }}</small>
        </div>
        <div class="col-12">
          <!--          <h4 class="d-inline-block mr-2">Artículo</h4>-->
          <span>{{ item.article.description }}</span>
        </div>
        <div class="col-7 offset-5 mt-2">
          <small class="float-right mt-1">{{ item.price }}</small>
          <span class="float-right">
            <small class="mr-3">{{ item.quantity }}</small>
            <small class="mr-3">x</small>
          </span>
        </div>
        <div class="col-12 mt-1">
          <span class="float-right">{{ (item.price * item.quantity).toFixed(2) }}</span>
          <h3 class="d-inline-block float-right mr-2">Importe (USD)</h3>
        </div>
        <div v-if="edit" class="col-12">
          <base-button
            class="rounded-pill btn btn-danger"
            title="Eliminar"
            size="sm"
            type="danger"
            @click="deleteItem(item.id, index)"
          >
            <i class="fas fa-trash mr-1"></i>Eliminar
          </base-button>
        </div>
      </div>
      <hr />
    </div>

    <div v-if="!edit" class="col-sm-12 d-none d-sm-block">
      <!-- SM MD LG XL -->
      <div class="row text-center">
        <div class="col-sm-2 offset-md-8">
          <h3>Subtotal</h3>
        </div>
        <div class="col-sm-2">
          {{ subtotal | toCurrencyUSD }}
        </div>
        <div class="col-sm-2 offset-md-8">
          <h3>IVA ({{ IVA }}%)</h3>
        </div>
        <div class="col-sm-2">
          {{ ivaDiscount | toCurrencyUSD }}
        </div>
        <div class="col-sm-2 offset-md-8">
          <h2>Total (USD)</h2>
        </div>
        <div class="col-sm-2 text-lg">
          {{ total | toCurrencyUSD }}
        </div>
        <div class="col-sm-2 offset-md-8">
          <h2>Total (ARS)</h2>
        </div>
        <div class="col-sm-2 text-lg">
          {{ totalInArs | toCurrencyARS }}
        </div>
      </div>
    </div>
    <div v-if="!edit" class="col-sm-12 d-block d-sm-none">
      <!-- XS -->
      <div class="row">
        <div class="col-10 offset-2">
          <h4 class="d-inline-block mx-3">Subtotal</h4>
          <span class="float-right text-sm">{{ subtotal | toCurrencyUSD }}</span>
        </div>
        <div class="col-10 offset-2">
          <h4 class="d-inline-block mx-3">IVA ({{ IVA }}%)</h4>
          <span class="float-right text-sm">{{ ivaDiscount | toCurrencyUSD }}</span>
        </div>
        <div class="col-10 offset-2">
          <h3 class="d-inline-block mx-3">TOTAL (USD)</h3>
          <span class="float-right">{{ total | toCurrencyUSD }}</span>
        </div>
        <div class="col-10 offset-2">
          <h3 class="d-inline-block mx-3">TOTAL (ARS)</h3>
          <span class="float-right">{{ totalInArs | toCurrencyARS }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrdersMixin from '@/mixins/ordersMixin';

export default {
  mixins: [OrdersMixin],
  props: {
    title: {
      type: String,
      default: 'Artículos',
    },

    add: {
      type: Boolean,
      default: true,
    },

    edit: {
      type: Boolean,
      default: true,
    },

    quotation: {
      type: Number,
      required: true,
    },
  },

  methods: {
    deleteItem(id, index) {
      this.$services
        .resource('quotation_items')
        .setQuotation(this.quotation)
        .delete(id)
        .then(() => this.items.splice(index, 1))
        .finally(() => {
          this.$success('El item fue eliminado con éxito!', 'Eliminado!');
        });
    },
  },
};
</script>
